import { TitleSubmissionRow } from '@framework/common-web/ui/inquiry/submission/TitleSubmissionRow.tsx';
import { FrontNotificationListSearchSchema } from '@framework/common-web/ui/notification/search/FrontNotificationListSearchSchema.ts';
import { searchableFrontNotificationFields } from '@framework/common-web/ui/notification/search/searchableFrontNotificationFields.tsx';
import { NotificationTableData } from '@framework/common-web/ui/notification/table/NotificationTableData.tsx';
import { t } from '@framework/i18n/intl/i18next.ts';
import { ResponsiveCard } from '@framework/ui/components/card/ResponsiveCard.tsx';
import { useBreadcrumbItem } from '@framework/ui/core/router/breadcrumbs/BreadcrumbContext.tsx';
import { type BrandedPath } from '@framework/ui/core/router/TypedRoute.tsx';
import { Divider } from 'antd';
import { type RouteComponentProps } from 'react-router';
import { useTheme } from 'styled-components';
import { PageLayout } from '../../../ui/layout/PageLayout.tsx';
import { FrontNotificationWrapper } from './FrontNotificationWrapper.tsx';
import { frontNotificationColumns } from './table/notificationColumns.tsx';

export interface INotificationListPageProps extends RouteComponentProps {}

const PAGE_TITLE_ID = 'notification-list-title-focus-id';

/**
 * Pagina di visualizzazione della lista delle notifiche.
 */
export function NotificationListPage(props: INotificationListPageProps) {
  useBreadcrumbItem({
    path: props.location.pathname as BrandedPath,
    title: 'Elenco Notifiche',
  });
  const theme = useTheme();

  return (
    <PageLayout isTablePage>
      <ResponsiveCard
        hideCardHeader={theme.searchButtonOnTableFlag}
        noPadding
        title={
          <TitleSubmissionRow id={PAGE_TITLE_ID}>
            {t('notification-list.pagina.titolo', 'Elenco Notifiche')}
          </TitleSubmissionRow>
        }
      >
        {!theme.searchButtonOnTableFlag && <Divider style={{ margin: 0 }} />}
        <FrontNotificationWrapper>
          <NotificationTableData
            columns={frontNotificationColumns}
            searchSchema={FrontNotificationListSearchSchema}
            searchableFields={searchableFrontNotificationFields}
          />
        </FrontNotificationWrapper>
      </ResponsiveCard>
    </PageLayout>
  );
}
